<template>
  <div>
    <div class="title-block">購入/予約選択</div>
    <p class="text-block">
      ※発車45分前を過ぎると、予約のみのお取り扱いはできません
    </p>
    <p class="text-block">
      ※展望席をご利用の場合は購入を選択してください。展望席は予約のみのお取り扱いはできません。
    </p>
    <div class="column">
      <div class="radio-wrap two-side">
        <div class="radio">
          <input
            id="radio-6"
            v-model="bookingOrPurchaseRadio"
            name="radio3"
            type="radio"
            :value="false"
          />
          <label for="radio-6" class="radio-label">購入</label>
        </div>
        <div class="radio">
          <input
            id="radio-7"
            v-model="bookingOrPurchaseRadio"
            name="radio3"
            type="radio"
            :value="true"
            :disabled="props.isReservationOnlyDisabled"
          />
          <label for="radio-7" class="radio-label">予約のみ</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useVModel } from "vue-composable";

export default {
  name: "MFITTBookingSelectBookingOrPurchase",
  props: {
    bookingOrPurchaseRadio: {
      type: Boolean,
      required: true,
    },
    isReservationOnlyDisabled: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const bookingOrPurchaseRadio = useVModel(props, "bookingOrPurchaseRadio");

    return {
      props,
      bookingOrPurchaseRadio,
    };
  },
};
</script>

<style lang="scss" scoped>
.title-block {
  margin: 20px 6px 8px;
  font-size: 13px;
  text-align: left;
  line-height: 17px;
  font-weight: bold;
}

.text-block {
  margin: 10px 6px;
  font-size: 12px;
  color: #ed2323;
}

.float-text {
  float: right;
  font-weight: normal;
}

.column .error-block {
  margin: 10px 0;
  font-size: 13px;
  font-weight: bold;
  text-align: right;
  line-height: 17px;
  color: #ff3333;
}

.column {
  margin-bottom: 16px;
  margin-top: 0;
}

/* ラジオボタン */
.radio-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0 5px;
}
.radio-wrap {
  justify-content: space-between;
}
.radio {
  margin: 0.5rem !important;
}
.radio input[type="radio"] {
  position: absolute;
  opacity: 0;
}
.radio input[type="radio"] + .radio-label:before {
  content: "";
  background: #f4f4f4;
  border-radius: 100%;
  border: 1px solid #b4b4b4;
  display: inline-block;
  width: 1.4em;
  height: 1.4em;
  position: relative;
  top: -0.2em;
  margin-right: 1em;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all 250ms ease;
}
.radio input[type="radio"]:checked + .radio-label:before {
  background-color: #ff7600;
  box-shadow: inset 0 0 0 4px #f4f4f4;
}
.radio input[type="radio"]:focus + .radio-label:before {
  outline: none;
  border-color: #ff7600;
}
.radio input[type="radio"]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio input[type="radio"] + .radio-label:empty:before {
  margin-right: 0;
}

.radio-wrap.two-side {
  justify-content: flex-start;
}
.radio-wrap.two-side .radio {
  width: calc(50% - 1rem);
}
</style>
